<div class="container container-margin">
  <div class="row">
    <h2>{{ translationService.getPopularProductsText() }}</h2>
  </div>
  <div class="row" class="table-row">
    <table mat-table [dataSource]="popularProducts" class="mat-elevation-z8">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let product" class="product-name-cell">
          {{ product.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="brand">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let product">{{ product.brand }}</td>
      </ng-container>

      <ng-container matColumnDef="viewAction">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let product">
          <a
            [routerLink]="['products/' + product.id + '/overview']"
            class="dark-link-underline"
          >
            {{ translationService.getViewText() }}
          </a>
        </td>
      </ng-container>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
